// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionInvoiceBreakdownRecordDto
 */
export interface IContributionInvoiceBreakdownRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    invoice_close_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    invoice_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {Date}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    transaction_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    contribution_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    contribution_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    posting_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IContributionInvoiceBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IContributionInvoiceBreakdownRecordDto interface.
 */
export function instanceOfIContributionInvoiceBreakdownRecordDto(value: object): value is IContributionInvoiceBreakdownRecordDto {
    return true;
}

export function IContributionInvoiceBreakdownRecordDtoFromJSON(json: any): IContributionInvoiceBreakdownRecordDto {
    return IContributionInvoiceBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IContributionInvoiceBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionInvoiceBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_close_date': json['invoice_close_date'] == null ? undefined : (new Date(json['invoice_close_date'])),
        'invoice_amount': json['invoice_amount'] == null ? undefined : json['invoice_amount'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'transaction_date': json['transaction_date'] == null ? undefined : (new Date(json['transaction_date'])),
        'contribution_date': json['contribution_date'] == null ? undefined : (new Date(json['contribution_date'])),
        'contribution_type': json['contribution_type'] == null ? undefined : json['contribution_type'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'posting_id': json['posting_id'] == null ? undefined : json['posting_id'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IContributionInvoiceBreakdownRecordDtoToJSON(json: any): IContributionInvoiceBreakdownRecordDto {
    return IContributionInvoiceBreakdownRecordDtoToJSONTyped(json, false);
}

export function IContributionInvoiceBreakdownRecordDtoToJSONTyped(value?: IContributionInvoiceBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_close_date': value['invoice_close_date'] == null ? undefined : ((value['invoice_close_date']).toISOString().substring(0,10)),
        'invoice_amount': value['invoice_amount'],
        'account_type': value['account_type'],
        'transaction_date': value['transaction_date'] == null ? undefined : ((value['transaction_date']).toISOString()),
        'contribution_date': value['contribution_date'] == null ? undefined : ((value['contribution_date']).toISOString().substring(0,10)),
        'contribution_type': value['contribution_type'],
        'memo': value['memo'],
        'plan_code': value['plan_code'],
        'posting_id': value['posting_id'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

